import { Tabs } from "expo-router";
import { GraduationCap, Home, Library, PieChart, PlusCircle, User } from "lucide-react-native";
import React from "react";
import { StyleSheet, View } from "react-native";
import { useSafeAreaInsets } from "react-native-safe-area-context";

import { useClientOnlyValue } from "@/components/useClientOnlyValue";
import { useColors } from "@/constants/theme";
import { useAppStore } from "@/stores/useStore";

export default function TabLayout() {
  const c = useColors();
  const insets = useSafeAreaInsets();
  const currentUser = useAppStore((state) => state.currentUser);
  const canUseTeacherTools =
    currentUser?.role === "teacher" || currentUser?.role === "admin";
  const tabBarBottomPadding = Math.max(insets.bottom, 16);
  const tabBarHeight = 78 + tabBarBottomPadding;

  return (
    <Tabs
      screenOptions={{
        tabBarActiveTintColor: c.primary,
        tabBarInactiveTintColor: c.textMuted,
        tabBarShowLabel: true,
        tabBarStyle: {
          display: "flex",
          height: tabBarHeight,
          overflow: "visible",
          paddingTop: 8,
          paddingBottom: tabBarBottomPadding,
          backgroundColor: c.surface,
          borderTopColor: c.border,
        },
        tabBarLabelStyle: { fontSize: 11, fontWeight: "600" },
        headerStyle: { backgroundColor: c.surface },
        headerTintColor: c.textPrimary,
        headerShown: useClientOnlyValue(false, true),
      }}
    >
      <Tabs.Screen
        name="index"
        options={{
          title: "ホーム",
          tabBarIcon: ({ color }) => <Home size={24} color={color} />,
        }}
      />
      <Tabs.Screen
        name="library"
        options={{
          title: "ライブラリ",
          tabBarIcon: ({ color }) => <Library size={24} color={color} />,
        }}
      />
      <Tabs.Screen
        name="create"
        options={{
          title: "投稿",
          tabBarActiveTintColor: c.warning,
          tabBarLabelStyle: {
            color: c.warning,
            fontSize: 12,
            fontWeight: "800",
            marginTop: 2,
          },
          tabBarItemStyle: styles.createTabItem,
          tabBarIcon: ({ focused }) => (
            <View
              style={[
                styles.createTabIcon,
                {
                  backgroundColor: focused ? c.warning : c.accent,
                  borderColor: c.surface,
                  shadowColor: c.primaryDark,
                },
              ]}
            >
              <PlusCircle size={32} color="#fff" strokeWidth={2.8} />
            </View>
          ),
        }}
      />
      <Tabs.Screen
        name="mylens"
        options={{
          title: "マイレンズ",
          tabBarIcon: ({ color }) => <PieChart size={24} color={color} />,
        }}
      />
      <Tabs.Screen
        name="teacher"
        options={{
          title: "先生",
          href: canUseTeacherTools ? undefined : null,
          tabBarIcon: ({ color }) => <GraduationCap size={24} color={color} />,
        }}
      />
      <Tabs.Screen
        name="profile"
        options={{
          title: "プロフィール",
          tabBarIcon: ({ color }) => <User size={24} color={color} />,
        }}
      />
    </Tabs>
  );
}

const styles = StyleSheet.create({
  createTabItem: {
    transform: [{ translateY: -10 }],
  },
  createTabIcon: {
    alignItems: "center",
    borderRadius: 999,
    borderWidth: 4,
    elevation: 7,
    height: 58,
    justifyContent: "center",
    shadowOffset: { width: 0, height: 8 },
    shadowOpacity: 0.22,
    shadowRadius: 14,
    width: 58,
  },
});
